import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import AuthForm from 'rebook/mybook/App/AuthForm';
import { URLS } from 'rebook/apps/base/constants';

import styles from './style.scss';


class LoginView extends React.Component {
  componentWillMount() {
    this.props.SeoActions.setData({
      canonicalUrl: `https://${BASE_HOST}/account/login/`,
    });
  }

  render() {
    const { user, shouldHideTitle } = this.props;
    let GALabel = 'RegisterPage';
    if (user) {
      return <Redirect to={URLS.dashboard} />;
    }

    return (
      <div className={classNames('backgroundContainer', 'themeGrey', styles.container)}>
        <div className="col-xs-4">
          {this.props.shouldHideTitle &&
          <React.Fragment>
            <div>
              <div className="title-1">Зарегистрируйтесь, чтобы начать</div>
            </div>
            <div className={styles.description}>
              <div className={styles.iconContainer}>
                <i className={styles.phonesIcon} />
                <span>Вы сможете читать книги на смартфоне, планшете и компьютере</span>
              </div>
            </div>
          </React.Fragment>}
          <div className="billetContainer">
            <AuthForm
              displaySocialAuth
              noSuccessNotification
              shouldHideTitle={shouldHideTitle}
              GALabel={GALabel}
              type="registration" />
          </div>
        </div>
      </div>
    );
  };
}

LoginView.propTypes = {
  shouldHideTitle: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);
